// import testPrint from "./config.testprint";

const config = {
  development: {
    oidcConfig: {
      authority: "https://auth.millo.omar.do",
      client_id: "portal-app",
      response_type: "code",
      scope: "openid profile email api",
      clockSkew: 900,
    },
    apiUrl: "http://localhost:5005",
		testAuthState: {
      ready: true,
      authenticated: true,
      suscription: null,
      user: {
        name: "Omar Peña",
        scopes: ["openid", "profile", "email", "api"]
      },
    },
    
    // testPages: {
			
		// 	page: [
		// 		testPrint
		// 	]
		// },
		testScopes: {
			_response: {
				ok: true,
				status: 200
			},
			accounts: [
			{
					"empresa": "dblk",
					"tipo": "empleado",
					"id": "0001",
					"label": "0001 - Omar",
					"name": "Omar Peña"
			}
		]
		}
  },
  test: {
    oidcConfig: {
      authority: "https://auth.iguala.do/realms/development",
      client_id: "portal-app",
      response_type: "code",
      scope: "openid profile email api",
      clockSkew: 900,
    },
    apiUrl: "https://api.dev.iguala.do",
  },
  release: {
    oidcConfig: {
      authority: "https://auth.iguala.do/realms/master",
      client_id: "portal-app",
      response_type: "code",
      scope: "openid profile email api",
      clockSkew: 900,
    },
    apiUrl: "https://api.iguala.do",
  },
};

export default config[(process.env.REACT_APP_ENV || process.env.NODE_ENV || "development").toLowerCase()];
